<template>
  <section class="fairy-display" @scroll="handleScroll" ref="container">
    <img class="banner" :src="bannerImg" @load="bannerLoad">
    <div class="nav-wrap" :class="{'nav-wrap-no-sub': !subNavShow}">
      <div class="nav-btn-con" :class="{'nav-btn-con-fixed': fixNavTop, 'nav-btn-no-sub': !subNavShow}" ref="navBtnCon">
        <div class="nav-top">
          <a class="nav-btn nav-btn-box nav-btn-all-box" :class="{
              'nav-btn-active': ids.indexOf(activeId) > -1,
              'nav-btn-active-box': ids.indexOf(activeId) > -1,
              'nav-split-left': ids[0] === ruixi && activeId === xiangyu,
              'nav-split-right': ids[0] === ruixi && activeId === fashin
            }" v-for="ids in topNavs" :key="ids[0]" :data-id="ids[0]" @click="handleNavClick">
          </a>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 图片展示 -->
      <div class="img-list-wrap" @click="handleClick">
        <div class="img-con" ref="imgCon" v-for="img in pictures" :key="img.id">
          <img :ref="img.id" :src="img.src" :data-id="img.id" />
        </div>
        <img class="img-con" :src="authorityImg" />
      </div>
    </div>
  </section>
</template>
<script>
// 仙女照承接页
import minirouterMethod from '@/mixins/minirouterMethod.js'
const IS_PROD = process.env.VUE_APP_ENV_MICRO === 'production'
const FASHIN = IS_PROD ? '8523' : '8523'
const RUI_XI = IS_PROD ? '8442' : '8442'
const XIANG_YU = IS_PROD ? '8443' : '8443'
const CATA_ID = IS_PROD ? '28408' : '28408'

export default {
  name: 'masterFamilyDisplay',
  mixins: [minirouterMethod],
  data() {
    return {
      activeId: null,
      bannerImg: require('./assets/banner.jpg'),
      authorityImg: require('./assets/authority.jpg'),
      navToTop: 0,
      topNavs: [[FASHIN], [RUI_XI], [XIANG_YU]],
      ruixi: RUI_XI,
      xiangyu: XIANG_YU,
      fashin: FASHIN,
      pictures: [
        {
          id: FASHIN,
          src: require('./assets/prod-fashion1.jpg'),
          name: '时尚1'
        },
        {
          id: FASHIN,
          src: require('./assets/prod-fashion2.jpg'),
          name: '时尚2'
        },
        {
          id: FASHIN,
          src: require('./assets/prod-fashion3.jpg'),
          name: '时尚3'
        },
        {
          id: RUI_XI,
          src: require('./assets/prod-rx.jpg'),
          name: '瑞喜'
        },
        {
          id: XIANG_YU,
          src: require('./assets/prod-xy.jpg'),
          name: '祥裕'
        }
      ],
      fixNavTop: false
    }
  },
  computed: {
    subNavShow() {
      return false
    }
  },
  methods: {
    async bannerLoad() {
      await this.$nextTick()
      this.navToTop = this.$refs.navBtnCon?.offsetTop || 0;
    },
    // 点击切换nav
    handleNavClick(e) {
      let prodId = e.target.dataset.id
      if (prodId) {
        this.activeId = String(prodId)
        let diff = 120
        if (prodId === FASHIN) diff = 130
        if (prodId === RUI_XI) diff = 118
        if (prodId === XIANG_YU) diff = 118
        this.$nextTick(() => {
          this.$refs['container'].scrollTop = this.$refs[this.activeId][0].offsetTop - this.$refs.navBtnCon.offsetHeight + diff
        })
      }
    },
    // 监听点击事件并跳转到对应产品
    handleClick(e) {
      this.miniRouterLink('gold', CATA_ID)
    },
    // 监听页面滚动
    handleScroll(e) {
      let scrolledDistance = e.target.scrollTop + window.innerHeight
      this.fixNavTop = e.target.scrollTop > this.navToTop - 10
      let imgCon = this.$refs.imgCon || [];
      if (imgCon.length === 0) {
        return;
      }
      let pictures = this.pictures

      if (scrolledDistance < imgCon[0].offsetTop) {
        this.activeId = pictures[0].id
        return
      }
      for (let i = 0; i < imgCon.length - 1; i++) {
        if (scrolledDistance > imgCon[i].offsetTop + 400 && scrolledDistance < imgCon[i + 1].offsetTop + 400) {
          this.activeId = pictures[i].id
        }
      }
      if (scrolledDistance > imgCon[imgCon.length - 1].offsetTop + 400) {
        this.activeId = pictures[imgCon.length - 1].id
      }
    }
  },
  mounted() {
    this.activeId = this.pictures[0].id
  }
}
</script>
<style lang="less" scoped>
  @import "./index.less";
</style>
